import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    backgroundColor: '#1e1e1e',
    color: '#ffffff',
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  borderColor: 'rgba(255, 255, 255, 0.12)',
  padding: theme.spacing(3),
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  borderTop: '1px solid rgba(255, 255, 255, 0.12)',
}));

export const DialogTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    color: '#ffffff',
    backgroundColor: '#1e1e1e',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.12)'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255, 255, 255, 0.2)'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#0078d4'
    }
  }
}));
